import { getFormValues } from 'redux-form';

export const getPageForm = getFormValues('page');
export const getPageTemplateForm = getFormValues('pageTemplate');
export const getUserProfileForm = getFormValues('UserProfile');
